import { Fragment } from 'react';
import { useSearchParams } from 'react-router-dom';

import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';

import SanitizeHtml from '@picsart/growth-rc/old/SanitizeHtml';

import useCategoryDataStore from 'templates/stores/categoryDataStore';
import useMasonryDataStore from 'templates/stores/masonryDataStore';
import useStyles from './styles';

const BottomInformation = () => {
  const styles = useStyles();

  const [searchParams] = useSearchParams();

  const { masonryData } = useMasonryDataStore(state => ({
    masonryData: state.masonryData,
  }));

  const { categoryData } = useCategoryDataStore(state => ({
    categoryData: state.category,
  }));

  const isBottomInfoDataVisible =
    Boolean(categoryData?.long_content?.length) &&
    Boolean(masonryData?.data.length) &&
    !searchParams.get('q');

  if (!isBottomInfoDataVisible) {
    return false;
  }

  return (
    <HorizontalContainer className={styles.root} dataTestId="bottom-information">
      <div className={styles.informationInnerHolder}>
        {categoryData?.long_content?.map(({ title, long_text_title, description, _id }, index) => (
          <Fragment key={`${_id}-${index}`}>
            <h2 className={styles.informationTitle}>{long_text_title || title}</h2>
            <div className={styles.informationItemHolder}>
              <SanitizeHtml html={description} tag="div" className={styles.informationItemText} />
            </div>
          </Fragment>
        ))}
      </div>
    </HorizontalContainer>
  );
};

export default BottomInformation;
